export const getFileNameFromPath = (
  path: string,
  { withExtension } = { withExtension: false }
): string | undefined => {
  const fileNameWithExtension = path.split('/').pop();
  return withExtension
    ? fileNameWithExtension
    : fileNameWithExtension?.split('.').shift();
};
